import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

/* ─── Inline translation resources (Statistics & shared keys) ─────────────── */
const statisticsTranslations = {
    fr: {
        translation: {
            /* ── Page header ── */
            "Statistiques": "Statistiques",
            "Toutes les périodes": "Toutes les périodes",
            "Filtrer par date": "Filtrer par date",
            "Appliquer": "Appliquer",
            "Fermer": "Fermer",
            "Réinitialiser": "Réinitialiser",
            "Produit": "Produit",
            "Tous les produits": "Tous les produits",
            /* ── Hero KPIs ── */
            "Total des commandes": "Total des commandes",
            "Chiffre d'affaire": "Chiffre d'affaire",
            "Profit net": "Profit net",
            "Dépense publicitaire": "Dépense publicitaire",
            "ROAS": "ROAS",
            "Bon": "Bon",
            /* ── Product list ── */
            "Liste des produits": "Liste des produits",
            "Voir tout": "Voir tout",
            /* ── Order metrics ── */
            "Métriques des commandes": "Métriques des commandes",
            "Nouvelles": "Nouvelles",
            "En attente": "En attente",
            "Confirmées": "Confirmées",
            "Annulées": "Annulées",
            "En att. traitement": "En att. traitement",
            "Confirmées sans statut stock ni livraison": "Confirmées sans statut stock ni livraison",
            "Emballées": "Emballées",
            "Livraison en cours": "Livraison en cours",
            "Livrées": "Livrées",
            "Retournées": "Retournées",
            "Payées": "Payées",
            "Impayées": "Impayées",
            /* ── Status chart ── */
            "Nouveau": "Nouveau",
            "Encours": "Encours",
            "Confirmée": "Confirmée",
            "Livrée": "Livrée",
            "Retournée": "Retournée",
            "Annulée": "Annulée",
            "Commandes": "Commandes",
            /* ── Rates ── */
            "Taux": "Taux",
            "Taux de confirmation": "Taux de confirmation",
            "Taux de livraison": "Taux de livraison",
            "Taux de retour": "Taux de retour",
            "Taux livraison global": "Taux livraison global",
            "Taux retour global": "Taux retour global",
            /* ── Finance ── */
            "Métriques financières": "Métriques financières",
            "Marge bénéficiaire": "Marge bénéficiaire",
            "AOV": "AOV",
            "Revenus ÷ Commandes livrées": "Revenus ÷ Commandes livrées",
            "Bénéfice par unité": "Bénéfice par unité",
            "Total des charges": "Total des charges",
            /* ── Line chart ── */
            "Évolution des Revenus et des Charges": "Évolution des Revenus et des Charges",
            "années": "années",
            "Revenus": "Revenus",
            "Charges": "Charges",
            "Aucune donnée de revenu ou de charge disponible": "Aucune donnée de revenu ou de charge disponible",
            /* ── Month labels ── */
            "Jan": "Jan",
            "Fév": "Fév",
            "Mar": "Mar",
            "Avr": "Avr",
            "Mai": "Mai",
            "Jui": "Jui",
            "Juil": "Juil",
            "Aou": "Aou",
            "Sep": "Sep",
            "Oct": "Oct",
            "Nov": "Nov",
            "Dec": "Dec",
            /* ── Advertising ── */
            "Métriques publicitaires": "Métriques publicitaires",
            "Coût par prospect": "Coût par prospect",
            "CPL Confirmé": "CPL Confirmé",
            "CPL Livré": "CPL Livré",
            "ROI": "ROI",
            "Break-even CPL": "Break-even CPL",
            /* ── Expenses chart ── */
            "Statistiques des charges": "Statistiques des charges",
            "Répartition": "Répartition",
            "Coûts": "Coûts",
            "TOTAL": "TOTAL",
            "Aucune donnée de charge disponible": "Aucune donnée de charge disponible",
            "Les charges apparaîtront ici une fois ajoutées": "Les charges apparaîtront ici une fois ajoutées",
            /* ── Charge labels ── */
            "Livraison": "Livraison",
            "Marketing": "Marketing",
            "Salaires": "Salaires",
            "Stock": "Stock",
            "Expédition": "Expédition",
            "Stockage": "Stockage",
            "Fulfillment": "Fulfillment",
            "Service COD": "Service COD",
            "Emballage": "Emballage",
            "Maintenance": "Maintenance",
            "Assurance": "Assurance",
            "Impôts": "Impôts",
            "Matériel": "Matériel",
            "Abonnement": "Abonnement",
            "Centre d'appels": "Centre d'appels",
            "Loyer": "Loyer",
            "Freelancer": "Freelancer",
            "Autre": "Autre",
            /* ── Breakdown ── */
            "Commandes par produit": "Commandes par produit",
            "Commandes par source": "Commandes par source",
            "Commandes par service": "Commandes par service",
            "Total": "Total",
            "Source": "Source",
            "Service": "Service",
            "Manuel": "Manuel",
            "Aucune donnée": "Aucune donnée",
            "Aucune donnée disponible": "Aucune donnée disponible",
            /* ── Rankings ── */
            "Classement des produits": "Classement des produits",
            "Meilleures ventes": "Meilleures ventes",
            "Profit le plus élevé": "Profit le plus élevé",
            "Meilleur profit/unité": "Meilleur profit/unité",
            "Taux de livraison le plus élevé": "Taux de livraison le plus élevé",
            "Taux de retour le plus élevé": "Taux de retour le plus élevé",
            "CA": "CA",
            "Profit": "Profit",
            "Profit/unité": "Profit/unité",
            "Taux liv.": "Taux liv.",
            "Taux ret.": "Taux ret.",
            /* ── Personnel ── */
            "Liste des personnels": "Liste des personnels",
            "Nombre de commandes en cours": "Nombre de commandes en cours",
            "Nombre de commandes confirmés": "Nombre de commandes confirmés",
            "Nombre de commandes livrés": "Nombre de commandes livrés",
            "Nombre de commandes annulés": "Nombre de commandes annulés",
            "Nombre de commandes Emballés": "Nombre de commandes Emballés",
            "Nombre de commandes Collectés": "Nombre de commandes Collectés",
            /* ── Toast / misc ── */
            "le compte est désactivé": "le compte est désactivé",
            /* ── Dashboard ── */
            "Nombre de personnels": "Nombre de personnels",
            "Nombre de commandes": "Nombre de commandes",
            "Nombre de produits": "Nombre de produits",
            "Réclamations": "Réclamations",
            "nouveaux": "nouveaux",
            "nouvelles": "nouvelles",
            "Statuts de commandes": "Statuts de commandes",
            "Les commandes livrées": "Les commandes livrées",
            "ce mois.": "ce mois.",
            "Code commande": "Code commande",
            "Client": "Client",
            "Gestionnaire": "Gestionnaire",
            "Prix": "Prix",
            "il n'y a pas encore de données.": "Il n'y a pas encore de données.",
            "produits": "produits",
            "basé sur les produits livrés": "Basé sur les produits livrés",
            "Graphique des commandes": "Graphique des commandes",
            "Top 10 produits": "Top 10 produits",
            "Jan": "Jan",
            "Sep": "Sep",
            "Oct": "Oct",
            "Nov": "Nov",
            "Dec": "Déc",
        }
    },
    en: {
        translation: {
            "Déconnexion": "Logout",
            /* ── Page header ── */
            "Statistiques": "Statistics",
            "Toutes les périodes": "All periods",
            "Filtrer par date": "Filter by date",
            "Appliquer": "Apply",
            "Fermer": "Close",
            "Réinitialiser": "Reset",
            "Produit": "Product",
            "Tous les produits": "All products",
            /* ── Hero KPIs ── */
            "Total des commandes": "Total orders",
            "Chiffre d'affaire": "Revenue",
            "Profit net": "Net profit",
            "Dépense publicitaire": "Ad Spend",
            "ROAS": "ROAS",
            "Bon": "Good",
            /* ── Product list ── */
            "Liste des produits": "Products list",
            "Voir tout": "See all",
            /* ── Order metrics ── */
            "Métriques des commandes": "Order Metrics",
            "Nouvelles": "New",
            "En attente": "On hold",
            "Confirmées": "Confirmed",
            "Annulées": "Cancelled",
            "En att. traitement": "Pending processing",
            "Confirmées sans statut stock ni livraison": "Confirmed with no stock or delivery status",
            "Emballées": "Packed",
            "Livraison en cours": "In delivery",
            "Livrées": "Delivered",
            "Retournées": "Returned",
            "Payées": "Paid",
            "Impayées": "Unpaid",
            /* ── Status chart ── */
            "Nouveau": "New",
            "Encours": "In progress",
            "Confirmée": "Confirmed",
            "Livrée": "Delivered",
            "Retournée": "Returned",
            "Annulée": "Canceled",
            "Commandes": "Orders",
            /* ── Rates ── */
            "Taux": "Rate",
            "Taux de confirmation": "Confirmation Rate",
            "Taux de livraison": "Delivery Rate",
            "Taux de retour": "Return Rate",
            "Taux livraison global": "Global Delivery Rate",
            "Taux retour global": "Global Return Rate",
            /* ── Finance ── */
            "Métriques financières": "Financial Metrics",
            "Marge bénéficiaire": "Profit Margin",
            "AOV": "AOV",
            "Revenus ÷ Commandes livrées": "Revenue ÷ Delivered Orders",
            "Bénéfice par unité": "Profit per unit",
            "Total des charges": "Total Expenses",
            /* ── Line chart ── */
            "Évolution des Revenus et des Charges": "Evolution of Income and Expenses",
            "années": "years",
            "Revenus": "Income",
            "Charges": "Expenses",
            "Aucune donnée de revenu ou de charge disponible": "No revenue or expense data available",
            /* ── Month labels ── */
            "Jan": "Jan",
            "Fév": "Feb",
            "Mar": "Mar",
            "Avr": "Apr",
            "Mai": "May",
            "Jui": "Jun",
            "Juil": "Jul",
            "Aou": "Aug",
            "Sep": "Sep",
            "Oct": "Oct",
            "Nov": "Nov",
            "Dec": "Dec",
            /* ── Advertising ── */
            "Métriques publicitaires": "Advertising Metrics",
            "Coût par prospect": "Cost per lead",
            "CPL Confirmé": "Confirmed CPL",
            "CPL Livré": "Delivered CPL",
            "ROI": "ROI",
            "Break-even CPL": "Break-even CPL",
            /* ── Expenses chart ── */
            "Statistiques des charges": "Expenses statistics",
            "Répartition": "Breakdown",
            "Coûts": "Costs",
            "TOTAL": "TOTAL",
            "Aucune donnée de charge disponible": "No expense data available",
            "Les charges apparaîtront ici une fois ajoutées": "Expenses will appear here once added",
            /* ── Charge labels ── */
            "Livraison": "Delivery",
            "Marketing": "Marketing",
            "Salaires": "Salaries",
            "Stock": "Stock",
            "Expédition": "Shipping",
            "Stockage": "Storage",
            "Fulfillment": "Fulfillment",
            "Service COD": "COD Service",
            "Emballage": "Packaging",
            "Maintenance": "Maintenance",
            "Assurance": "Insurance",
            "Impôts": "Taxes",
            "Matériel": "Material",
            "Abonnement": "Subscription",
            "Centre d'appels": "Call Center",
            "Loyer": "Rent",
            "Freelancer": "Freelancer",
            "Autre": "Other",
            /* ── Breakdown ── */
            "Commandes par produit": "Orders by Product",
            "Commandes par source": "Orders by Source",
            "Commandes par service": "Orders by Service",
            "Total": "Total",
            "Source": "Source",
            "Service": "Service",
            "Manuel": "Manual",
            "Aucune donnée": "No data",
            "Aucune donnée disponible": "No data available",
            /* ── Rankings ── */
            "Classement des produits": "Product Rankings",
            "Meilleures ventes": "Best Selling",
            "Profit le plus élevé": "Highest Profit",
            "Meilleur profit/unité": "Best Profit/Unit",
            "Taux de livraison le plus élevé": "Highest Delivery Rate",
            "Taux de retour le plus élevé": "Highest Return Rate",
            "CA": "Revenue",
            "Profit": "Profit",
            "Profit/unité": "Profit/Unit",
            "Taux liv.": "Deliv. Rate",
            "Taux ret.": "Return Rate",
            /* ── Personnel ── */
            "Liste des personnels": "List of staff",
            "Nombre de commandes en cours": "Number of orders in progress",
            "Nombre de commandes confirmés": "Number of confirmed orders",
            "Nombre de commandes livrés": "Number of delivered orders",
            "Nombre de commandes annulés": "Number of cancelled orders",
            "Nombre de commandes Emballés": "Number of packed orders",
            "Nombre de commandes Collectés": "Number of collected orders",
            /* ── Toast / misc ── */
            "le compte est désactivé": "The account is disabled",
            /* ── Dashboard ── */
            "Nombre de personnels": "Number of staff",
            "Nombre de commandes": "Number of orders",
            "Nombre de produits": "Number of products",
            "Réclamations": "Complaints",
            "nouveaux": "new",
            "nouvelles": "new",
            "Statuts de commandes": "Order statuses",
            "Les commandes livrées": "Delivered orders",
            "ce mois.": "this month.",
            "Code commande": "Order code",
            "Client": "Client",
            "Gestionnaire": "Manager",
            "Prix": "Price",
            "il n'y a pas encore de données.": "No data yet.",
            "produits": "products",
            "Produits": "Products",
            "basé sur les produits livrés": "Based on delivered products",
            "Graphique des commandes": "Orders Chart",
            "Top 10 produits": "Top 10 products",
            "Jan": "Jan",
            "Sep": "Sep",
            "Oct": "Oct",
            "Nov": "Nov",
            "Dec": "Dec",
            //business
            "Client": "Customer",
            "Sélectionnez votre Business": "Select your Business",
            "Choisissez un espace de travail pour continuer": "Choose a workspace to continue",
            "Sélectionnez un business auquel vous avez accès": "Select a business you have access to",
            "Gérer": "Manage",
            "Réessayer": "Try again",
            "Impossible de charger vos espaces de travail. Vérifiez votre connexion.": "Unable to load your workspaces. Please check your connection.",
            "Vous avez accès uniquement aux businesses auxquels vous êtes assigné.": "You only have access to the businesses you are assigned to.",
            "actifs": "active",
            "créés": "created",
            "Aucun business créé": "No business created",
            "Créez votre premier espace de travail pour commencer": "Create your first workspace to get started",
            "Créer un Business": "Create a Business",
            "Aucun business accessible": "No accessible business",
            "Vous n'avez pas encore été assigné à un espace de travail.": "You have not yet been assigned to a workspace.",
            "Contactez votre administrateur pour obtenir l'accès.": "Contact your administrator to get access.",
            "Limite atteinte. Veuillez mettre à niveau votre plan.": "Limit reached. Please upgrade your plan.",
            "Nouveau Business": "New Business",
            "illimité": "unlimited",
            "Votre abonnement est expiré.": "Your subscription has expired.",
            "Veuillez mettre à niveau votre plan.": "Please upgrade your plan.",
            "Vous avez atteint la limite de {{max}} business actif(s).": "You have reached the limit of {{max}} active business(es).",
            "Limite d'activation atteinte": "Activation limit reached",
            "INACTIF": "INACTIVE",
            "Cet espace de travail est désactivé": "This workspace is disabled",
            "Manager": "Manager",
            "Livrées": "Delivered",
            "ce mois.": "this month.",
            "il n'y a pas encore de données.": "No data yet.",
            "Plan:": "Plan:"
        }
    }
};

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "fn",
        debug: false,
        saveMissing: false,
        missingKeyHandler: false,
        // Inline resources act as fallback when the http backend hasn't loaded
        // or when a key is missing from the loaded locale JSON files.
        resources: statisticsTranslations,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;
